import { useTrainingMutations } from '@/app/hooks/useTrainingMutations'
import { Button } from '@/view/components/ui/button'
import { DialogContent } from '@/view/components/ui/dialog'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/view/components/ui/form'
import { Input } from '@/view/components/ui/input'
import { Separator } from '@/view/components/ui/separator'
import { Switch } from '@/view/components/ui/switch'
import { Textarea } from '@/view/components/ui/textarea'
import useTrainingForm, {
  TrainingFormValues,
} from '../../hooks/useTrainingForm'
import { useTrainingFormContext } from '../../providers/TraningFormProvider'

interface TrainingFormProps {
  defaultValues?: TrainingFormValues
}

export const TrainingForm = ({ defaultValues }: TrainingFormProps) => {
  const { form } = useTrainingForm({ defaultValues })

  const { createTraining, isCreating, updateTraining, isUpdating } =
    useTrainingMutations()

  const { setIsCreateTrainingModalOpen } = useTrainingFormContext()

  const description = form.watch('description')
  const isEdit = !!defaultValues

  const handleSubmit = form.handleSubmit(async (data) => {
    try {
      if (isEdit) {
        if (!defaultValues?._id) return

        const payload = {
          trainingId: defaultValues?._id as string,
          training: data,
        }

        await updateTraining(payload)
      } else {
        await createTraining(data)
      }

      setIsCreateTrainingModalOpen(false)
    } catch (error) {
      console.error(error)
    }
  })

  return (
    <DialogContent className="flex w-[492px] flex-col gap-0 rounded-3xl">
      <h1 className="mb-2 text-2xl font-semibold">
        {isEdit ? 'Editar Treinamento' : 'Criar Treinamento'}
      </h1>
      <Separator />
      <Form {...form}>
        <form className="mt-8 space-y-4" onSubmit={handleSubmit}>
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Nome</FormLabel>
                <FormControl>
                  <Input placeholder="Treinamento Exemplo" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Descrição</FormLabel>
                <FormControl>
                  <Textarea placeholder="Explique seu treinamento" {...field} />
                </FormControl>
                <FormMessage />
                <div className="flex justify-end">
                  <span className="text-sm text-muted-foreground">
                    {description.length}/500
                  </span>
                </div>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="isSellersApp"
            render={({ field }) => (
              <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
                <div className="space-y-0.5">
                  <FormLabel className="text-base">Vendedores</FormLabel>
                </div>
                <FormControl>
                  <Switch
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="isTeamsApp"
            render={({ field }) => (
              <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
                <div className="space-y-0.5">
                  <FormLabel className="text-base">Líderes</FormLabel>
                </div>
                <FormControl>
                  <Switch
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <Button
            disabled={isCreating || isUpdating}
            className="w-full rounded-full text-white"
            type="submit"
          >
            {isEdit ? 'Salvar Alterações' : 'Criar Treinamento'}
          </Button>
        </form>
      </Form>
    </DialogContent>
  )
}
